var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-main"},[_vm._v("\n  ユーザー名："+_vm._s(_vm.user.get('username'))+"\n  権限："+_vm._s(_vm.type)+"\n  "),(_vm.isAdmin)?_c('user-total'):_vm._e(),(_vm.isAdmin)?_c('edit-main'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }